import React, { useMemo } from 'react'
import styled from 'styled-components'
import parse from 'html-react-parser'
// @ts-ignore
import { useSysTheme } from 'hooks/useUiState'
import { isRightToLeftText, rightToLeftStyles, setMarkers } from 'utils/rtlTextUtil'
import Domain from 'enums/Domain'
import { getTwitterComplianceText } from 'utils/twitterComplianceUtil'
import { replaceEmojiWithTwEmoji } from 'utils/emojiUtil'
import { StreamSymbol } from 'enums'
import { useTranslation } from 'react-i18next'
import { SystemTheme } from 'hooks/useUiState/types'
import { useContextMediaDetail } from './context'

const Container = styled.div<{ $theme: SystemTheme; isRTL: boolean }>`
  color: ${({ $theme }) => $theme.text.primary};
  font-size: ${({ $theme }) => $theme.typescale[14].size};
  line-height: ${({ $theme }) => $theme.typescale[14].lineHeight};
  font-weight: ${({ $theme }) => $theme.fontWeight.regular};
  overflow-wrap: anywhere;
  word-break: normal;
  ${({ isRTL }) => isRTL && rightToLeftStyles}
  > a {
    color: ${({ $theme }) => $theme.interaction.primary.default};
    text-decoration: none;
  }
  white-space: pre-line;

  display: flex;
  flex-direction: column;
  gap: 24px;
`

const StyledTitle = styled.div<{ $theme: SystemTheme }>`
  font-size: ${({ $theme }) => $theme.typescale[14].size};
  line-height: ${({ $theme }) => $theme.typescale[14].lineHeight};
  font-weight: ${({ $theme }) => $theme.fontWeight.semibold};
`

const Message = () => {
  const theme = useSysTheme()
  const { t } = useTranslation()
  const mediaDetail = useContextMediaDetail()
  const {
    message,
    domain,
    mentionedUrls,
    dataStream,
    podcastEpisodeDescription,
    podcastTranscript
  } = mediaDetail
  const isRTL = isRightToLeftText(message)
  const displayText = useMemo(() => {
    if (!message) {
      return ''
    }
    let formattedMessage
    formattedMessage = setMarkers(message)
    if (domain === Domain.TWITTER) {
      formattedMessage = getTwitterComplianceText(formattedMessage || '', mentionedUrls || [])
    }
    formattedMessage = replaceEmojiWithTwEmoji(formattedMessage || '')
    return formattedMessage
  }, [message, domain, mentionedUrls])

  if (dataStream === StreamSymbol.PODCAST) {
    return (
      <Container $theme={theme} isRTL={isRTL}>
        {podcastEpisodeDescription && (
          <div>
            <StyledTitle $theme={theme}>{t('episodeDescription')}</StyledTitle>
            <div>{parse(podcastEpisodeDescription ?? '')}</div>
          </div>
        )}
        <div>
          <StyledTitle $theme={theme}>{t('transcript')}</StyledTitle>
          <div>{parse(podcastTranscript ?? '')}</div>
        </div>
      </Container>
    )
  }

  return (
    <Container $theme={theme} isRTL={isRTL}>
      {parse(displayText)}
    </Container>
  )
}

export default Message
